<template>
  <v-container>

    <v-row v-if="isMobile">
      <v-col>
        <v-sheet
            v-for="(event, i) in timeline"
            :key="i"
            class="mb-3"
        >
          <v-card class="text-left">
            <v-card-title class="text-break" :class="`headline font-weight-light mb-4 ${event.color}--text`">{{ event.title }}</v-card-title>
            <v-card-subtitle class="text-justify">
              <b>{{ event.date }}</b>
              <br />
              <span v-html="event.desc"></span>
            </v-card-subtitle>
          </v-card>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col>
          <div v-if="loading">Loading...</div>
      </v-col>
      <v-timeline>
        <v-timeline-item
            v-for="(event, i) in timeline"
            :key="i"
            :color="event.color"
            small
        >
            <template v-slot:opposite>
                <span
                    :class="`headline font-weight-bold ${event.color}--text`"
                    v-text="event.date"
                ></span>
            </template>

            <v-card class="text-left">
                <v-row no-gutters>
                    <v-card-title :class="`font-weight-bold mb-4 ${event.color}--text`"> {{ event.title }}</v-card-title>
                    <v-img
                      v-if="event.imgSrc"
                      :src="event.imgSrc"
                      max-height="50"
                      contain
                    ></v-img>
                </v-row>
                <v-card-subtitle class="font-weight-bold">
                  <span v-html="event.desc"></span>
                </v-card-subtitle>
                <v-card-subtitle v-if="isMobile">
                    <b>{{event.date}}</b>
                </v-card-subtitle>
            </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-row>
  </v-container>
</template>

<script>

import config from "@/config"
export default {

  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
    return false;
    }
  },

  data: () => ({
    timeline: [
      // {
      //     color: "black",
      //     date: "dd.mm.rrrr",
      //     title: "Partner projektu promocji MPG",
      //     desc: 'Szanowni Państwo, <br /><br />Miło Nam jest poinformować, iż oficjalnym partnerem projektu realizowanego dla Ministerstwa Gospodarki "Przygotowanie oraz realizacja programu promocji Marki Polskiej Gospodarki poprzez umieszczenie ogłoszeń na mobilnych nośnikach reklamy w ramach realizowanego przez Ministerstwo Gospodarki projektu systemowego pn. Promocja polskiej gospodarki na rynkach międzynarodowych" została firma Logintrans sp. z o.o.',
      //     imgSrc: require(`../assets/news/wizual_na_strone_0_0.thumbnail.jpg`)
      // },
      {
          color: "black",
          date: "31.03.2023 r.",
          title: "Fundusze Europejskie dla Pomorza Zachodniego",
          desc: 'W dniu 31.03.2023 r. miało miejsce oficjalne uruchomienie programu Fundusz Europejskie dla Pomorza Zachodniego. Szczegóły programu można znaleźć pod adresem: <a href="https://www.rpo.wzp.pl/fepz/nabory-fepz">www.rpo.wzp.pl/fepz/nabory-fepz</a>;'
      },
      {
          color: "black",
          date: "31.03.2023 r.",
          title: "Harmonogramy wsparcia funduszy europejskich",
          desc: 'Zamieszczono pierwsze harmonogramy wsparcia dla programów założonych do realizacji: <a href="https://www.funduszeeuropejskie.gov.pl/strony/o-funduszach/fundusze-2021-2027/">HARMONOGRAMY</a>'
      },
    ],
    loading: true,
  }),
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const response = await fetch(config.API_URL + 'posts?_fields=title,content,date');
        const result = await response.json();
        let parsedData = [];
        result.forEach(element => {
          parsedData.push(
            {
              color: "black",
              date: new Date(element.date).toLocaleDateString('pl-PL') + ' r.',
              title: element.title.rendered,
              desc: element.content.rendered
            }
          )
        });
        this.timeline = [...parsedData, ...this.timeline];
      } catch (error) {
        console.error(error.message);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
